import { VueRecaptchaPlugin } from 'vue-recaptcha';

export default defineNuxtPlugin((nuxtApp) => {
  const { recaptcha } = useRuntimeConfig().public.frontkit;

  nuxtApp.vueApp.use(VueRecaptchaPlugin, { v2SiteKey: recaptcha?.siteKey });
});
